import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import auth from './modules/auth'
import alert from './modules/alert'
import search from './modules/search'
import player from './modules/player'
import article from './modules/article'
import gtag from './modules/gtag'

Vue.use(Vuex)

const state = {
  clientWidth: document.documentElement.clientWidth
}

const mutations = {
  resize: (state, data) => {
    state.clientWidth = document.documentElement.clientWidth
  }
}

export default new Vuex.Store({
  state,
  // getters,
  mutations,
  // actions,
  modules: {
    user,
    auth,
    alert,
    article,
    search,
    player,
    gtag
  },

  // Making sure that we're doing
  // everything correctly by enabling
  // strict mode in the dev environment.
  strict: process.env.NODE_ENV !== 'production'
})
